<img [src]="imageName | imgConfiguration:defaultValue | async" 
    [ngStyle]="{'max-height': height}"
    [attr.width]="width" [attr.height]="height" class="m-auto">